import { inject } from "vue";
import directive from "../Directives/Linkify.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  __name: "NcAppSidebarHeader",
  props: {
    /**
     * The name used in NcAppSidebar header.
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Title to display for the name.
     */
    title: {
      type: String,
      default: void 0
    },
    /**
     * Linkify the name.
     */
    linkify: {
      type: Boolean
    }
  },
  setup(__props) {
    const headerRef = inject("NcAppSidebar:header:ref");
    return { __sfc: true, headerRef, vLinkify: directive };
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _c("h2", { directives: [{ name: "linkify", rawName: "v-linkify", value: { text: _vm.name, linkify: _vm.linkify }, expression: "{ text: name, linkify }" }], ref: "headerRef", attrs: { "tabindex": "-1", "title": _vm.title } }, [_vm._v(" " + _vm._s(_vm.name) + " ")]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NcAppSidebarHeader = __component__.exports;
export {
  NcAppSidebarHeader as N
};
//# sourceMappingURL=NcAppSidebarHeader-CBE4tNYb.mjs.map
